import { Box, List, ListItem, styled } from '@mui/material';

import { TableRowItem } from './TableRowItem';

import type { HubReportStatus } from '#entities';

export interface TableRowGroupItemProps {
  region: string;
  rows: HubReportStatus[];
  startIndex: number; // for alternating row colors (even/odd)
}

const PREFIX = 'TSMED-HubsReport-TableRowGroupItem';
const tableRowGroupItemClasses = {
  group: `${PREFIX}-group`,
  groupHeader: `${PREFIX}-groupHeader`,
  rows: `${PREFIX}-rows`,
};

const Root = styled(ListItem)(({ theme: { utils, palette } }) => ({
  display: 'grid',
  gridTemplateColumns: 'var(--region-column-width) 1fr',
  alignItems: 'stretch',
  padding: 0,
  [`.${tableRowGroupItemClasses.groupHeader}`]: {
    position: 'sticky',
    left: 0,
    top: 0,
    zIndex: 3,
    alignSelf: 'stretch',
    background: '#000',
    color: palette.grey[200],
    display: 'flex',
    blockSize: '100%',
  },
  [`.${tableRowGroupItemClasses.groupHeader} .label`]: {
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
    transform: 'rotate(180deg)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    padding: '16px 8px',
    fontSize: utils.clamp(12, 16),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    blockSize: '100%',
  },
  [`.${tableRowGroupItemClasses.rows}`]: {
    display: 'grid',
    gridAutoRows: 'minmax(0, auto)',
    padding: 0,
    margin: 0,
    borderTop: '2px solid #657c93',
    width: 'max-content',
    minWidth: '100%',
  },
}));

export const TableRowGroupItem = ({
  region,
  rows,
  startIndex,
}: TableRowGroupItemProps) => (
  <Root>
    <Box className={tableRowGroupItemClasses.groupHeader}>
      <Box className="label">{region}</Box>
    </Box>

    <List className={`${tableRowGroupItemClasses.rows}`}>
      {rows.map((row, index) => (
        <TableRowItem
          key={row.location.abbreviation}
          row={row}
          isEven={(startIndex + index) % 2 === 1}
        />
      ))}
    </List>
  </Root>
);
